import { useContainer } from '@hub-la/fe-container';
import { HttpClient } from '@hub-la/fe-core-http-client';
import { useQuery } from 'react-query';
import { GetPdfFileUrl } from '../../usecases/get-pdf-file-url.js';

const useGetPdfFileUrl = asset => {
  const container = useContainer();
  const {
    isSuccess,
    isError,
    error,
    isLoading,
    data
  } = useQuery(['get-pdf-file-url', asset === null || asset === void 0 ? void 0 : asset.id], () => new GetPdfFileUrl(container.get(HttpClient)).execute(asset), {
    initialData: null,
    refetchOnWindowFocus: false
  });
  return {
    isSuccess,
    isError,
    error,
    isLoading,
    data
  };
};

export { useGetPdfFileUrl };
